import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setLanguage, t } from "../i18n";
import styles from "./registerform.module.css";
import DarkModeToggle from "./DarkModeToggle";
import ErrorModal from "./ErrorModal";
import LogoEn from "../assets/logo_punchline_en.png";
import LogoZh from "../assets/logo_punchline_zh.png";

const RegisterForm = ({ setLoggedIn }) => {
  const [languageState, setLanguageState] = useState(sessionStorage.getItem("language") || "en");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const submitHandler = async (event) => {
    event.preventDefault();
    try {
      const res = await fetch(process.env.REACT_APP_API_PATH + "/auth/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          password,
          attributes: {
            username,
          },
        }),
      })
      const result = await res.json();
      if (result.userID) {
        sessionStorage.setItem("token", result.token);
        sessionStorage.setItem("user", result.userID);
        setLoggedIn(true);
        navigate("/quiz");
      } else {
        setErrorMessage("Failed to create account. Please try again.");
        setShowModal(true);
      }
    } catch (err) {
      setErrorMessage("An error occurred. Please try again later.");
      setShowModal(true);
    };
  };

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      navigate("/");
    }
  }, [navigate]);

  const changeLanguage = (language) => {
    setLanguage(language);
    setLanguageState(language);
  };
<form onSubmit={submitHandler} className={styles.form} autoComplete="off">
  <div className={styles.inputContainer}>
    <input
      type="text"
      placeholder=" "
      className={styles.input}
      value={username}
      onChange={(e) => setUsername(e.target.value)}
      autoComplete="off"
    />
    <label className={styles.label}>{t("username")}</label>
  </div>

  <div className={styles.inputContainer}>
    <input
      type="email"
      placeholder=" "
      className={styles.input}
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      autoComplete="off"
    />
    <label className={styles.label}>{t("email")}</label>
  </div>

  <div className={styles.inputContainer}>
    <input
      type="password"
      placeholder=" "
      className={styles.input}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      autoComplete="off"
    />
    <label className={styles.label}>{t("password")}</label>
  </div>

  <button type="submit" className={styles.signUpButton}>{t("sign_up")}</button>
</form>
  const getLogo = () => {
    if (languageState === "en") return LogoEn;
    else if (languageState === "zh") return LogoZh;
  };

  return (
    <div className={styles.container}>
      {/* Error Modal */}
      <ErrorModal show={showModal} onClose={() => setShowModal(false)} title={t("registration_failed")} message={errorMessage} />

      {/* Left Side - Logo Placeholder */}
      <div className={styles.logoContainer}>
        <img src={getLogo()} alt="Logo" className={styles.logoText} />
      </div>

      {/* Right Side - Register Form */}
      <div className={styles.registerBox}>
        <h1 className={styles.title}>{t("create_account")}</h1>
        <form onSubmit={submitHandler} className={styles.form}>

          {/* Username Field */}
          <div className={styles.inputContainer}>
            <input type="text" placeholder=" " className={styles.input} value={username} onChange={(e) => setUsername(e.target.value)} />
            <label className={styles.label}>{t("username")}</label>
          </div>

          {/* Email Field */}
          <div className={styles.inputContainer}>
            <input type="email" placeholder=" " className={styles.input} value={email} onChange={(e) => setEmail(e.target.value)} />
            <label className={styles.label}>{t("email")}</label>
          </div>

          {/* Password Field */}
          <div className={styles.inputContainer}>
            <input type="password" placeholder=" " className={styles.input} value={password} onChange={(e) => setPassword(e.target.value)} />
            <label className={styles.label}>{t("password")}</label>
          </div>

          {/* Sign Up Button */}
          <button type="submit" className={styles.signUpButton}>{t("sign_up")}</button>
        </form>

        {/* Navigation Links */}
        <div className={styles.linkContainer}>
          <Link to="/" className={styles.link}>{t("login")}</Link>
          <Link to="/reset-password" className={styles.link}>{t("forgot_password")}</Link>
        </div>
        <div className={styles.languageSwitcher}>
          <span onClick={() => changeLanguage('en')} className={styles.languageText}>English</span>
          <span onClick={() => changeLanguage('zh')} className={styles.languageText}>中文</span>
        </div>
      </div>
      <DarkModeToggle />
    </div>
  );
};

export default RegisterForm;
